import { PropsWithChildren } from "react";
import theme from "../app/app-theme";

export default function FilterSection({ children }: PropsWithChildren<{}>) {
    return <div style={{ backgroundColor: theme.palette.info.light, padding: '8px', borderRadius: '4px' }}>
        {children}
    </div>;
};